import { Box, Grid, Link, Paper, Typography } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { CONTATTI } from "../../../global/urlMapping";

export const InfoColonRetto = () => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <>
            <Box
                className="emptyBg"
                sx={{
                    flexGrow: 1,
                    overflow: 'hidden',
                    with: "100%"
                }}>
                <Box sx={{ x: 'auto' }}>
                    <Grid container wrap="nowrap" spacing={2}>
                        <Grid item xs zeroMinWidth>

                            <Box sx={{ width: "100%", height: "150px", display: "flex" }}>
                                <Typography
                                    component='h1'
                                    sx={{
                                        color: "#005397",
                                        margin: "auto",
                                        textAlign: "center",
                                        fontSize: { xs: "25px", md: "40px" },
                                        fontWeight: 700,
                                    }}
                                >
                                    Screening Colon retto
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                <Box sx={{ my: 4, mx: 'auto', paddingBottom: "20vh" }}>
                    <Grid container wrap="nowrap" spacing={2}>
                        <Grid item xs zeroMinWidth>
                            <Box
                                sx={{
                                    width: "80%",
                                    margin: "auto",
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                <Paper
                                    elevation={6}
                                    sx={{
                                        minHeight: "150px",
                                        borderRadius: "20px",
                                        textDecoration: "none !important",
                                        display: "flex",
                                        width: { xs: "100%", md: "60%" },
                                        padding: "0px",
                                        margin: "auto",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#005397",
                                            fontSize: { xs: "20px", md: "20px" },
                                            textAlign: "center",
                                            margin: "auto 20px",
                                            flexDirection: "column",
                                            mt: "30px",
                                            mb: "30px"
                                        }}
                                    >


                                        <strong>Sangue occulto nelle feci</strong><br /><br />
                                        E' un esame <strong>gratuito semplice e non doloroso. </strong>
                                        Lo screening serve a <strong>verificare che non ci sia sangue occulto </strong>
                                        (cioè non visibile) <strong>nelle feci</strong>.
                                        Si effettua ogni <strong>2 anni. </strong><br /><br />

                                        Se hai <strong>tra i 50 e 74 anni </strong>
                                        riceverai una <strong>lettera personale</strong> con tutte le <strong>istruzioni </strong>
                                        per ritirare il flaconcino per le feci e dove consegnarlo.<br /><br />

                                        Il risultato dell'esame ti sarà inviato a casa per posta, a tuo nome.
                                        Se dovessero servire altri controlli ti chiameremo.<br /><br />
                                        Rivolto a: <strong>Uomini e Donne</strong><br /><br />

                                        {`Per avere maggiori informazioni, consulta l'area `}
                                        <Link href={CONTATTI} title="Contatti" sx={{ fontWeight: 'bold', "&:hover": { textDecoration: 'underline' } }}>
                                            Contatti e Informazioni
                                        </Link>.

                                    </Typography>
                                </Paper>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

            </Box>

        </>
    );
};
